export enum SpendingType {
    Target = "target",
    Material = "material",
    Infrastructure = "infrastructure",
    School = "school",
    Education = "education",
    Other = "other",
}

export const spendingTypeTitle = {
    [SpendingType.Target]: "Организация целевого обучения студентов в рамках бюджетных квот образовательной организации",
    [SpendingType.Material]: "Укрепление учебно-материальной базы образовательных организаций",
    [SpendingType.Infrastructure]: "Совершенствование имущественной инфраструктуры  образовательной организации",
    [SpendingType.School]: "Профориентационные мероприятия и работа со школьниками",
    [SpendingType.Education]: "Дополнительное образование сотрудников организации",
    [SpendingType.Other]: "Прочие расходы",
}

export interface Finance {
    id: number
    companyId: number
    universityBranchId: number
    spendingType: SpendingType
    cooperationSubject: string
    yearFinal: number
    yearForecast: number
}
